export async function authFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, init);

  if (response.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/';
  }

  return response;
}
